<template>
<div>
  <div style="margin-top: 25px;">
    <b-tabs
        :pills="tabs.isPills"
        :small="tabs.isSmall"
        :justified="tabs.isJustified"
        :isFill="tabs.isFill"
        :end="tabs.isEnd"
        :vertical="tabs.isVertical"
        content-class="mt-3"
        defaultActiveKey="invitation" >
      <b-tab
          v-for="(aSection, index) in availSections"
          :key="index"
          :title="aSection.title"
      >
        <component
            :is="aSection.component"
            v-bind="Object.assign({}, propsData)"
            :ref="aSection.componentName"
        >
        </component>
      </b-tab>
    </b-tabs>
  </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import SessionEmail from "./sessionEmail";
export default {
  name: "Sessions_Sidebar_Email_And_Text",
  components: {},
  props: {
    session: {
      type: Object,
      default: () => { return {}}
    },
    profile: {
      type: Object,
      default: () => { return {}}
    },
    theme: {
      type: Object,
      default: () => { return {}}
    },
    notificationJson: {
      type: Object,
      default: () => { return {}}
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({}),
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        form: this.formSession,
        notificationJson: this.notificationJson
      };
    }
  },
  methods: {},
  data() {
    return {
      tabs: {
        isPills: true,
        isSmall: false,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: true
      },
      sections : [
        {
          title: "Invitation",
          id: "invitation",
          component: SessionEmail,
          componentName: "SessionEmail",
          avail: true
        },
        {
          title: "Registration Confirmation",
          id: "confirmation",
          component: SessionEmail,
          componentName: "SessionEmail",
          avail: true
        },
        {
          title: "Reminders",
          id: "reminders",
          component: SessionEmail,
          componentName: "SessionEmail",
          avail: true
        },
        {
          title: "Thank You and Feedback",
          id: "thankyou",
          component: SessionEmail,
          componentName: "SessionEmail",
          avail: true
        },
      ],
    };
  }
};
</script>

<style lang="scss" scoped>

</style>
